import {useMemo} from "react";
import _ from "lodash";
import {useTranslation} from "react-i18next";
import {SOILS} from "../utils/enumItemsUtils";
import {Soil} from "../types/domain/soil";

export const useSoils = () => {
    const {t} = useTranslation();

    return useMemo(() => {
        const soils: Soil[] = SOILS.map((item) => ({id: item.id, name: t(`enumerations.soils.${item.i18nKey}`)}));

        return {
            soils,
            soilsById: _.keyBy(soils, "id"),
        };
    }, [t]);
};
